import { req } from '../utils/request'

export class CandidateRecommend {
  getCommittees() {
    return req.post('user.candidate_recommend/committees')
  }

  getList(params) {
    return req.post('user.candidate_recommend/getList', params)
  }

  getDetail(params) {
    return req.post('user.candidate_recommend/getDetail', params)
  }

  submit(params) {
    return req.post('user.candidate_recommend/submit', params)
  }

  update(params) {
    return req.post('user.candidate_recommend/update', params)
  }
}

export default new CandidateRecommend()
